import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  label: string
  isArchived: boolean
  onEdit: () => void
  onDelete: () => void
}

const Item: React.FC<Props> = ({ label, isArchived, ...actions }) => (
  <Box
    flexDirection="row"
    alignItems="center"
    padding="s16"
    width="full"
    cursor={!isArchived ? 'pointer' : 'default'}
    background={isArchived ? 'grey100' : undefined}
  >
    <Icon.Medium icon="drag-and-drop" />
    <Box width="full" paddingLeft="s4" flexDirection="row" gap="s16" alignItems="center" inline>
      <Text.Normal color="grey800" size="300" weight="medium">
        {label}
      </Text.Normal>
    </Box>
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        <PopoverMenu.TouchableOption title={i18n.t('common.edit')} onClick={actions.onEdit} />
        <PopoverMenu.TouchableOption
          title={i18n.t('job_catalog.remove_level')}
          onClick={actions.onDelete}
          danger
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  </Box>
)

export default observer(Item)
